/* eslint-disable */
import Immutable from 'immutable';
import { createStructuredSelector } from 'reselect';
import qs from 'querystring';

import { formatMessageDate } from 'utils/date/formatUnixDate';
import parseCatch from 'utils/parseCatch';
import firebaseNode from 'firebase/firebaseNode';
import { FirebaseMain } from 'firebase/firebase';
import ApiService from 'services/ApiService/ApiService';

import {
  CONTACTS_URL,
  CONVERSATIONS_URL,
  DELETE_CONVERSATION_URL,
  FILE_UPLOAD_URL,
  REPORT_ABUSE_URL,
  UNREAD_THREADS_URL,
} from './Api';


const ADD_CONVERSATION = 'cam4/Settings/Inbox/ADD_CONVERSATION';
const ADD_MESSAGE = 'cam4/Settings/Inbox/ADD_MESSAGE';
const ADD_UNREAD_THREAD = 'cam4/Settings/Inbox/ADD_UNREAD_THREAD';
const DELETE_CONVERSATION = 'cam4/DELETE_CONVERSATION';
const GET_CONVERSATION = 'cam4/GET_CONVERSATION';
const GET_CONVERSATIONS = 'cam4/GET_CONVERSATIONS';
const PUSH_MESSAGE = 'cam4/Settings/Inbox/PUSH_MESSAGE';
const REPORT_USER = 'cam4/Settings/Inbox/REPORT_USER';
const RESET_STATE = 'cam4/Settings/Inbox/RESET_STATE';
const SET_CONTACTS = 'cam4/SET_CONTACTS';
const SET_CURRENT_USER = 'cam4/Settings/Inbox/SET_CURRENT_USER';
const SET_UNREAD_THREADS = 'cam4/Settings/Inbox/SET_UNREAD_THREADS';
const UNREAD_THREADS = 'cam4/Settings/Inbox/UNREAD_THREADS';
const UPDATE_CONVERSATION = 'cam4/Settings/Inbox/UPDATE_CONVERSATION';
const UPDATE_CONVERSATIONS_ORDER = 'cam4/Settings/Inbox/UPDATE_CONVERSATIONS_ORDER';
const UPDATE_CONVERSATION_MESSAGES = 'cam4/Settings/Inbox/UPDATE_CONVERSATION_MESSAGES';
const UPDATE_CURRENT_THREADID = 'cam4/Settings/Inbox/UPDATE_CURRENT_THREADID';
const UPDATE_PREVIEW = 'cam4/Settings/Inbox/UPDATE_PREVIEW';
const UPDATE_UNREAD_COUNT = 'cam4/Settings/Inbox/UPDATE_UNREAD_COUNT';

const initialState = Immutable.fromJS({
  changeActiveTab: false,
  conversations: [],
  conversation: {},
  contacts: [],
  messages: [],
  threadId: null,
  fromNotification: false,
  unreadThreads: [],
});

export let currentUserId = null;

let currentConversations = undefined;
let currentThreadId = undefined;

export const NAME = 'conversations';

const conversations = (state) => state[NAME].get('conversations');
const conversation = (state) => state[NAME].get('conversation');
const contacts = (state) => state[NAME].get('contacts');
const messages = (state) => state[NAME].get('messages');
const fromNotification = (state) => state[NAME].get('fromNotification');
const unreadThreads = (state) => state[NAME].get('unreadThreads');

function moveConversation(conversations, threadId, message, currentThreadId) {
  let convoFound = undefined;
  let convos = conversations.filter((convo) => {
    if (convo && convo.threadId === threadId) {
      convoFound = Object.assign({}, convo);
      const newUnreadMsgCount =
        currentThreadId && threadId !== currentThreadId ? convoFound.unreadMsgCount + 1 : convoFound.unreadMsgCount;
      if (message) {
        const newPreview = Object.assign({}, convoFound.preview);
        newPreview.message = message.message;
        convoFound.preview = newPreview;
      }
      convoFound.unreadMsgCount = newUnreadMsgCount;

      return convo.threadId !== threadId;
    }

    return true;

  });

  return (convos = [convoFound, ...convos]);
}

function updateNewConvo(conversations, message) {
  let convoFound = undefined;
  let convos = conversations.filter((convo) => {
    if (convo && convo.threadId === 0) {
      convoFound = Object.assign({}, convo);

      const newUnreadMsgCount = 0;
      if (message) {
        const newSendDate = formatMessageDate(message.sendDate);
        const newPreview = Object.assign({}, convoFound.preview);
        newPreview.sendDate = newSendDate;
        newPreview.message = message.message;
        convoFound.preview = newPreview;
      }
      convoFound.unreadMsgCount = newUnreadMsgCount;

      return false;
    } else if (convo) {
      return true;
    }

    return false;

  });

  return (convos = [convoFound, ...convos]);
}

// eslint-disable-next-line complexity
export default function reducer(state = initialState, action) {
  let threadId = 0;
  let convos = [];
  let updateUnreadCountValue = undefined;

  switch (action.type) {
    case GET_CONVERSATIONS:
      currentConversations = action.conversations;

      return state.set('conversations', action.conversations);
    case UPDATE_UNREAD_COUNT:
      currentThreadId = action?.message?.threadId;
      threadId = action?.message?.threadId;

      if (threadId !== state.get('threadId')) {
        updateUnreadCountValue = state.get('conversations').map((thread) => {
          if (thread.threadId === threadId) {
            // Copy the object before mutating
            const newUnreadMsgCount = thread.unreadMsgCount + 1;

            return Object.assign({}, thread, { unreadMsgCount: newUnreadMsgCount });
          }

          return thread;
        });
      } else {
        updateUnreadCountValue = state.get('conversations');
      }

      return state.set(
        'conversations',
        updateUnreadCountValue
      );
    case UNREAD_THREADS:
      currentThreadId = action.id;
      threadId = action.id;

      return state
        .set(
          'conversations',
          state.get('conversations').map((thread) => {
            if (thread.threadId === threadId) {
              // Copy the object before mutating
              return Object.assign({}, thread, { unreadMsgCount: 0 });
            }

            return thread;
          })
        )
        .set(
          'unreadThreads',
          state.get('unreadThreads').filter((thread) => thread !== action.id)
        );
    case UPDATE_CONVERSATIONS_ORDER:
      convos = moveConversation(state.get('conversations'), action.threadId, null, state.get('threadId'));

      return state.set('conversations', convos);
    case UPDATE_CURRENT_THREADID:
      currentThreadId = action.threadId;

      return state.set('threadId', action.threadId);
    case GET_CONVERSATION:
      currentThreadId = action.conversation.thread.threadId;

      return state
        .set('fromNotification', false)
        .set('conversation', state.get('conversation').merge(action.conversation.thread))
        .set('threadId', action.conversation.thread.threadId);
    case SET_CONTACTS:
      return state.set('contacts', action.contacts);
    case DELETE_CONVERSATION:
      currentConversations = state.get('conversations').filter((c) => c.threadId !== action.threadId);

      return state.set(
        'conversations',
        state.get('conversations').filter((c) => c.threadId !== action.threadId)
      );
    case ADD_CONVERSATION:
      currentConversations = [action.conversation, ...state.get('conversations')];

      return state.set('conversations', [action.conversation, ...state.get('conversations')]);
    case UPDATE_CONVERSATION:
      convos = updateNewConvo(state.get('conversations'), action.message);

      return state.set('conversations', convos);
    case ADD_MESSAGE:
      convos = state.get('conversations');
      if (
        convos.length > 0 &&
        action.payload.mType !== 'video' &&
        action.payload.mType !== 'image' &&
        !action.isFirst
      ) {
        convos = moveConversation(
          state.get('conversations'),
          action.payload.threadId,
          action.payload,
          state.get('threadId')
        );
      }

      return action.payload && state.get('threadId') === action.payload.threadId ? state
        .set('fromNotification', action.fromNotification)
        .set('conversations', convos)
        .set('messages', [...state.get('messages'), action.payload]) : state;
    case PUSH_MESSAGE:
      return state.set('messages', [action.payload, ...state.get('messages')]);
    case SET_CURRENT_USER:
      currentUserId = action.user_id;

      return state;
    case RESET_STATE:
      return state.set('messages', []);
    case UPDATE_PREVIEW:
      return state.set(
        'conversations',
        state.get('conversations').map((thread) => {
          if (thread && thread.threadId === action.message.threadId) {
            let unreadMsgCount = 0;
            if (currentThreadId !== action.message.threadId) {
              unreadMsgCount = thread?.unreadMsgCount || 1;
            }

            return Object.assign({}, thread, {
              preview: action.message,
              unreadMsgCount,
            });
          }

          return thread;
        })
      );
    case UPDATE_CONVERSATION_MESSAGES:
      return state.set(
        'conversations',
        state.get('conversations').map((thread) => {
          if (thread.threadId === action.message.threadId) {
            return Object.assign({}, thread, { messages: [action.message, ...thread.messages] });
          }

          return thread;
        })
      );
    case SET_UNREAD_THREADS:
      return state.set('unreadThreads', action.unreadThreads);
    case ADD_UNREAD_THREAD:
      if (!state.get('unreadThreads').includes(action.thread)) {
        return state.set('unreadThreads', state.get('unreadThreads').concat(action.thread));
      }

      return state;
    default:
      return state;
  }
}

function updateConversations(conversations) {
  return {
    type: GET_CONVERSATIONS,
    conversations,
  };
}

function updateConversationsOrder(threadId) {
  return {
    type: UPDATE_CONVERSATIONS_ORDER,
    threadId,
  };
}

function updateCurrentThreadId(threadId) {
  return {
    type: UPDATE_CURRENT_THREADID,
    threadId,
  };
}

function udpateUnreadCount(message) {
  return {
    type: UPDATE_UNREAD_COUNT,
    message,
  };
}

function updateConversation(res) {
  return {
    type: GET_CONVERSATION,
    conversation: res.data,
  };
}

function updatePreview(message) {
  return {
    type: UPDATE_PREVIEW,
    threadId: message.threadId,
    message,
  };
}

function updateContacts(res) {
  return {
    type: SET_CONTACTS,
    contacts: res.data,
  };
}

function updateNewConversation(message) {
  return {
    type: UPDATE_CONVERSATION,
    message,
  };
}

function updateConversationMessages(message) {
  return {
    type: UPDATE_CONVERSATION_MESSAGES,
    message,
  };
}

function addConversation(receiver, sender, message = {}) {
  const conversation = {
    lastMessageReadId: null,
    threadId: message.threadId,
    preview: message,
    read: false,
    unreadMsgCount: 0,
    users: { receiver, sender },
    isMassAdminThread: false,
    lastPerformerMassMessageReadId: 0,
  };

  return {
    type: ADD_CONVERSATION,
    conversation,
  };
}

function addMessage(message, isFirst) {
  return {
    type: ADD_MESSAGE,
    payload: message,
    fromNotification: Object.hasOwn(message, 'msgId') && message?.id !== 'newUploadMedia',
    isFirst,
  };
}

function removeConversation(threadId) {
  return {
    type: DELETE_CONVERSATION,
    threadId,
  };
}

function reportUserFn() {
  return { type: REPORT_USER };
}

function readConversation(threadId) {
  return {
    type: UNREAD_THREADS,
    id: threadId,
  };
}

function pushMessage(payload) {
  return {
    type: PUSH_MESSAGE,
    payload,
  };
}

function setCurrentUserId(userId) {
  return {
    type: SET_CURRENT_USER,
    'user_id': userId,
  };
}

function stateToInitialValues() {
  return { type: RESET_STATE };
}

function setUnreadThreads(unreadThreads) {
  return {
    unreadThreads,
    type: SET_UNREAD_THREADS,
  };
}

function addUnreadThread(thread) {
  return {
    thread,
    type: ADD_UNREAD_THREAD,
  };
}

const getUnreadThreads = (headers) => (dispatch) =>
  ApiService.get(UNREAD_THREADS_URL, { headers })
    .then((res) => dispatch(setUnreadThreads(res.data.unreadThreads)))
    .catch((err) => parseCatch(err));

function getConversations(user, callback) {
  const params = {
    mode: 'getThreads',
    limit: 999,
    filter: '',
  };

  return (dispatch) => ApiService
    .get(CONVERSATIONS_URL, { params })
    .then((res) => {
      if (res.data && res.data.conversations) {
        const threadId = -1 * parseInt(user.user.get('user').toJS().userId, 10);
        dispatch(updateConversations(res.data.conversations.filter((obj) => obj.threadId !== threadId)));
        if (typeof callback === 'function') {
          callback(res.data.conversations.filter((obj) => obj.threadId !== threadId));
        }
      }
    });
}

function getContacts(user, str = '') {
  const url = CONTACTS_URL(user.username);
  const params = {
    partialUsername: str,
    limit: 50,
    accessToken: user.accessToken,
  };

  return (dispatch) => ApiService
    .get(url, { params })
    .then((res) => dispatch(updateContacts(res)));
}

function createConversation(message, receiver, sender, callback) {
  const params = { username: `${receiver},${sender}` };

  return (dispatch) => ApiService
    .put(CONVERSATIONS_URL, { params })
    .then((res) => {
      message.threadId = res.data.thread_id;
      const data = qs.stringify(message);
      const headers = { 'content-type': 'application/x-www-form-urlencoded' };

      return ApiService.post(CONVERSATIONS_URL, { data, headers });
    })
    .then((res) => {
      dispatch(addMessage(message, true));
      dispatch(updateNewConversation(message));
      callback(res.data);
    });
}

function preppendConversation(receiver, sender, message = {}, callback) {
  return (dispatch) => {
    dispatch(addConversation(receiver, sender, message));
    callback();
  };
}

function getConversation(query, callback) {
  const params = {
    mode: 'loadConversation',
    threadId: query.threadId,
    offset: query.offset,
    limit: 25,
  };

  return (dispatch) => ApiService
    .get(CONVERSATIONS_URL, { params })
    .then((res) => {
      dispatch(updateConversation(res));
      callback(res.data);
    });
}

function deleteConversation(threadId, callback) {
  const url = ApiService.substitute(DELETE_CONVERSATION_URL, { threadId });

  return (dispatch) => ApiService
    .delete(url)
    .then((res) => {
      dispatch(removeConversation(threadId));
      callback(res.data);
    });
}

function sendMessage(payload, callback) {
  const headers = { 'content-type': 'application/x-www-form-urlencoded' };
  const data = qs.stringify(payload);

  return (dispatch) => ApiService
    .post(CONVERSATIONS_URL, { data, headers })
    .then((res) => {
      dispatch(addMessage(payload, false));
      callback(res.data);
    });
}

function getExtension(filename) {
  const result = filename.match(/[^.]*$/);

  return result?.[0] || '';
}

function getUploadUrl(file, user, callback) {
  const fileName = file.name;
  const extension = getExtension(fileName);
  const data = qs.stringify({
    size: file.size,
    contentType: file.type,
    extension,
    username: user.username,
    accessHash: user.accessHash,
  });
  const headers = { 'content-type': 'application/x-www-form-urlencoded' };

  return () => ApiService
    .post(FILE_UPLOAD_URL, { data, headers })
    .then((res) => {
      callback(res.data, data);
    });
}

function uploadFile(message, callback) {
  return (dispatch) => {
    message.msgId = message.id;
    dispatch(addMessage(message));
    callback(message);
  };
}

function markAsRead(threadId) {
  const data = qs.stringify({ threadId });
  const headers = { 'content-type': 'application/x-www-form-urlencoded' };

  return (dispatch) => ApiService
    .post(UNREAD_THREADS_URL, { data, headers })
    .then(() => {
      dispatch(readConversation(threadId));
    });
}

function updateUnreadMessages(message) {
  return (dispatch) => {
    dispatch(udpateUnreadCount(message));
  };
}

function setCurrentThreadId(threadId) {
  return (dispatch) => {
    dispatch(updateCurrentThreadId(threadId));
  };
}

function moveConversationToTop(threadId) {
  return (dispatch) => {
    dispatch(updateConversationsOrder(threadId));
  };
}

function watchConversationState(user) {
  const { username } = user;
  const conversationStateRef = FirebaseMain.child(firebaseNode.USER_NOTIFICATION).child(username.toLowerCase());

  return (dispatch) => {
    // update chat inside inbox real time
    conversationStateRef.on('value', (snapshot) => {
      const message = snapshot.val();
      if (message) {
        const hasMsgId = Object.hasOwn(message, 'msgId');
        // update unread threads number for header mail icon
        if (hasMsgId && message?.senderId !== user.user.getIn(['user', 'userId'])) {
          dispatch(addUnreadThread(message.threadId));
        }

        message.sendDate = formatMessageDate(message.sendDate);

        if (
          hasMsgId &&
          message?.senderId !== currentUserId &&
          currentThreadId === message.threadId
        ) {
          const convExists = currentConversations?.filter((convo) => {
            if (convo !== null) {
              return (convo.threadId === message.threadId || convo.threadId === 0);
            }

            return false;
          }).length;
          if (!convExists) {
            // create conversation
            dispatch(preppendConversation(username, message.displayName, message, () => undefined));
          }
          dispatch(addMessage(message));
          if (message?.threadId) {
            dispatch(updateConversationsOrder(message.threadId));
          }
        } else {
          const convExists = currentConversations?.filter((convo) => {
            if (convo !== null) {
              return (convo.threadId === message.threadId || convo.threadId === 0);
            }

            return false;
          }).length;

          if (!convExists) {
            // create conversation
            if (message.threadId) {
              dispatch(preppendConversation(username, message.displayName, message, () => undefined));
            }
          } else if (message?.threadId) {
            dispatch(updateConversationsOrder(message.threadId));
          }
        }

        dispatch(updatePreview(message));
      }
    });
  };
}

function resetConversationMessages() {
  return (dispatch) => {
    dispatch(stateToInitialValues());
  };
}

function reportUser(payload, callback) {
  const headers = { 'content-type': 'application/x-www-form-urlencoded' };
  const data = qs.stringify(payload);

  return (dispatch) => ApiService
    .post(REPORT_ABUSE_URL, { data, headers })
    .then((res) => {
      dispatch(reportUserFn);
      callback(res.data);
    });
}

function pushTempMessage(payload) {
  return (dispatch) => {
    dispatch(pushMessage(payload));
  };
}

function setCurrentUserIdAction(userId) {
  return (dispatch) => {
    dispatch(setCurrentUserId(userId));
  };
}

export const selector = createStructuredSelector({
  conversations,
  conversation,
  contacts,
  messages,
  fromNotification,
  unreadThreads,
});

export const actionCreators = {
  getConversations,
  getConversation,
  getContacts,
  sendMessage,
  getUploadUrl,
  uploadFile,
  deleteConversation,
  createConversation,
  markAsRead,
  watchConversationState,
  resetConversationMessages,
  updateUnreadMessages,
  moveConversationToTop,
  setCurrentThreadId,
  reportUser,
  preppendConversation,
  pushTempMessage,
  setCurrentUserIdAction,
  updateConversationMessages,
  getUnreadThreads,
};
